import React, {ChangeEvent, useEffect} from 'react';

import styles from './Checkbox.module.css'
import {cn} from "../../../../utils/cn.ts";

interface Props {
    label?: string
    onChange?: (value: ChangeEvent) => void
    onClick?: () => void
    checked?: boolean
    disabled?: boolean
    viewType?: 'regular' | 'radio' | 'check'
    className?: string
}

export const Checkbox: React.FC<Props> = ({
                                              className,
                                              onChange,
                                              onClick,
                                              label,
                                              checked,
                                              disabled,
                                              viewType = 'regular'
}) => {
    useEffect(() => {

    }, [checked]);

    return (<div className={styles.wrapper} onClick={onClick}>
        <input
            className={cn(
                viewType === 'regular' && styles.checkbox,
                viewType === 'radio' && styles.radio,
                viewType === 'check' && styles.check,
                disabled && styles.disabled,
                className
            )}
            type='checkbox'
            onChange={onChange}
            checked={checked}
            disabled={disabled}
        />
        {label && <div className={styles.checkboxName}>{label}</div>}
    </div>);
};